// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"1094e921","453":"fb455376","470":"2234b740","725":"a5283d38","831":"cc52cb82"}[chunkId] + ".chunk.js";
};